module.exports = __webpack_public_path__ + "static/program-3000-f3b9efa84bfd71e844801ad90644d451.jpg";